import React, { useRef, useState } from "react";
import { Button } from "react-bootstrap";
import { useAuth } from "../../../context/AuthContext";
import { db, storage } from "../../../firebase";
import { notifyError, notifyTopRight } from "../toast/SetToast";
import { canSendAnnualMaskTestEmail, queueAnnualMaskTestEmail } from "./annualMaskTestEmail";

const AnnualMaskTestEmailButton = ({ caseItem, disabled = false }) => {
  const { currentUser } = useAuth();
  const [sending, setSending] = useState(false);
  const inFlight = useRef(false);
  if (!canSendAnnualMaskTestEmail(currentUser)) return null;
  const send = async () => {
    if (disabled || inFlight.current) return;
    inFlight.current = true;
    setSending(true);
    try {
      const recipient = await queueAnnualMaskTestEmail({ database: db, fileStorage: storage, currentUser, caseItem });
      notifyTopRight(`Test email queued to ${recipient}.`);
    } catch (error) { notifyError(error.message || "Unable to queue test email."); }
    finally { inFlight.current = false; setSending(false); }
  };
  return (
    <Button type="button" size="sm" variant="outline-warning" className="mr-2 mb-2"
      disabled={disabled || sending || !caseItem || !caseItem.doctorEmail}
      title="Sends from and to pisanu@braindynamics.co.th using the assigned doctor’s template and normal email wording. Attaches the CPAP Usage Report and Sleep Study Report. Does not change case status."
      onClick={send}>
      <i className="fa fa-envelope-o mr-1" />{sending ? "Queueing test…" : "Test Send to Doctor"}
    </Button>
  );
};
export default AnnualMaskTestEmailButton;
